// extracted by mini-css-extract-plugin
module.exports = {"root":"HeroHeading_root__39pKG","Content":"HeroHeading_Content__1b32X","SubContent":"HeroHeading_SubContent__1rm_O"};